/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {service as StateService} from "../../../Services/StateService";

export class StateFieldViewer extends BaseFieldViewer {
	constructor(props) {
		super(props);

		this.setInitialState({
			states: []
		});
	}

	@autobind
	shouldReloadData(prevProps, prevState) {
		return this.props.Value != prevProps.Value;
	}

	@autobind
	loadData() {
		super.loadData();

		StateService.Get()
			.then((x) => {
				this.setState({states: x.result});
			});
	}

	@autobind
	getState() {
		let state = this.state.states.find((x) => x.stateId == this.props.Value);

		return state;
	}

	@autobind
	_render() {
		return this.getState() ? this.getState().name : "N/A";
	}
}